import { render } from "./CommunityContent.vue?vue&type=template&id=042a710a"
import script from "./CommunityContent.vue?vue&type=script&lang=js"
export * from "./CommunityContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__